import React from "react";
import ComponentWrapper from "../EntrypointWrapper";

export function HeroBanner300px(props) {
  return (
    <div
      className="pt-[9.7rem] pb-[4.6rem] 1400px:pb-[7.1rem] 1400px:pt-[8.7rem] min-h-[30rem] bg-cover bg-no-repeat"
      style={{ backgroundImage: `url(${props.backgroundImgUrl})` }}
    >
      <ComponentWrapper
        breakpointContainer={true}
        className="px-[4.5rem] md:px-[5.6rem] 1400px:px-0"
      >
        {props.h1 && (
          <h1 className="text-[3rem] leading-[4rem] 1400px:text-[3.9rem] 1400px:leading-[5.2rem] font-medium text-[#00A3F6] mb-[1.9rem] 1400px:mb-[1.6rem] ">
            {props.h1}
          </h1>
        )}

        {props.p && (
          <p className="text-[1.8rem] leading-[2.4rem] 1400px:text-[2.8rem] 1400px:leading-[3.7rem] text-[#FFFFFF]  font-normal md:max-w-[70rem] 1400px:max-w-[95rem]">
            {props.p}
          </p>
        )}

        
        {props.p2 && (
          <p className="mt-[1rem] text-[1.2rem] leading-[2rem] 1400px:text-[2rem] 1400px:leading-[3rem] text-[#00A3F6] font-normal md:max-w-[44.6rem] 1400px:max-w-[67.2rem]">
            {props.p2}
          </p>
        )}
        {props.p3 && (
          <p className="text-[1.2rem] leading-[2rem] 1400px:text-[2rem] 1400px:leading-[3rem] text-[#FFFFFF] font-normal md:max-w-[44.6rem] 1400px:max-w-[67.2rem]">
            {props.p3}
          </p>
        )}
        
      </ComponentWrapper>
    </div>
  );
}
